import { render, staticRenderFns } from "./UserPointReg.vue?vue&type=template&id=705da8fe"
import script from "./UserPointReg.vue?vue&type=script&lang=js"
export * from "./UserPointReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports